import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { APP_CONFIG } from '../../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class AdminAccessService {
    url: any;
    domainUrl = environment.apiurl;
    gyanDomainUrl = environment.gyanApiUrl;
    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    createAccess(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.createAccess;
        return this.http.post(url, req, { headers: headers });
    }

    updateAccess(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.updateAccess;
        return this.http.post(url, req, { headers: headers });
    }
    getAccessList(req: any): Observable<any> {
        const url = this.gyanDomainUrl + this.config.apis.admin.listofAccess;
        return this.http.post(url, req);
    }
}
